import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=08ad36ff"
import script from "./Finish.vue?vue&type=script&lang=ts"
export * from "./Finish.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports